import { render } from "./TargetingFilterItem.vue?vue&type=template&id=2e83d2ec"
import script from "./TargetingFilterItem.vue?vue&type=script&lang=js"
export * from "./TargetingFilterItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__